import axios from "axios";
import { logout } from "./login/login-services.js";

const envApiUrl =
	(typeof import.meta !== "undefined" && import.meta?.env?.VITE_API_BASE_URL) ||
	process.env.API_BASE_URL;

const getDefaultApiUrl = () => {
	const defaultUrl = "https://api.canaletico.es";

	if (typeof envApiUrl === "string" && envApiUrl.trim() !== "") {
		return envApiUrl.trim();
	} else {
        return defaultUrl;
    }
};

export const API_URL = getDefaultApiUrl();

//CREAMOS INSTANCIA DE AXIOS
const api = axios.create({
	baseURL: API_URL,
	headers: {
		"Content-Type": "application/json",
	},
	timeout: 30000,
});

export const getApiBaseUrl = () => {
    const baseUrl = api?.defaults?.baseURL;
    if (typeof baseUrl === "string" && baseUrl.trim() !== "") {
        return baseUrl.trim();
    }
    return API_URL || "";
};

export const buildApiUrl = (relativePath = "") => {
    const normalizedBase = getApiBaseUrl().replace(/\/+$/, "");
    if (!relativePath) {
        return normalizedBase;
    }

    const normalizedPath = relativePath.startsWith("/") ? relativePath : `/${relativePath}`;
    return `${normalizedBase}${normalizedPath}`;
};

export const buildAuthenticatedFetchOptions = (overrides = {}) => {
    const token =
        typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
    const clientUrl =
        typeof window !== "undefined" ? window.location.href : "";

    const headers = {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(clientUrl ? { "X-Client-URL": clientUrl } : {}),
        ...(overrides.headers || {}),
    };

    return {
        ...overrides,
        headers,
    };
};

//INTERCEPTOR PARA AÑADIR EL TOKEN Y LA CABECERA X-Client-URL A LAS PETICIONES
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Añadir X-Client-URL con la URL actual del navegador
        const clientUrl = window.location.href;
        config.headers["X-Client-URL"] = clientUrl;

        return config;
    },
    (error) => Promise.reject(error),
);

// INTERCEPTOR PARA MANEJAR RESPUESTAS
let unauthorizedLogout = null;
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const token = localStorage.getItem("token");
        const requestPath = String(error.config?.url || "").split("?")[0].replace(/\/+$/, "");
        if (error.response && error.response.status === 401 && token &&
            !requestPath.endsWith("/users/logout") && !unauthorizedLogout) {
            // Several requests can reject the same expired session together.
            // The logout request itself must never recursively start another one.
            unauthorizedLogout = Promise.resolve(logout()).finally(() => {
                unauthorizedLogout = null;
            });
        }
        return Promise.reject(error);
    }
);

export default api;
